import { SVGInterface } from "../../interface";

const ViewTableVertical = ({ color, ...rest }: SVGInterface) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M20 20L20 4C20 2.9 19.1 2 18 2L6 2C4.9 2 4 2.9 4 4L4 20C4 21.1 4.9 22 6 22L18 22C19.1 22 20 21.1 20 20ZM6 8L6 4L18 4L18 8L6 8ZM6 14L6 10L18 10L18 14L6 14ZM6 20L6 16L18 16L18 20L6 20Z"
      fill={color || "#0E171F"}
    />
    <rect x="11" y="3" width="2" height="18" fill={color || "#0E171F"} />
  </svg>
);

export default ViewTableVertical;
